import Vue from 'vue'

/**
 * Modalidade da empresa logada (coluna `empresas.modalidade`, espelhada em
 * `modalidades.modalidade`): `ERP`, `NFE` (Emissor), `FIS` (Fiscal), `ASS`
 * (Assinatura Digital) e `COB` (Cobranças).
 *
 * O `usuarioLogado` vem por parâmetro de propósito: quem chama de dentro de um
 * componente passa o do Vuex (reativo) e quem chama de uma action passa o
 * `rootState` — assim este arquivo não precisa importar a store e não cria
 * dependência circular com `shared/store`.
 */
export const pegaModalidade = (usuarioLogado = Vue.prototype.$usuarioLogado) => {
    if (
        !usuarioLogado
        || !usuarioLogado.Empresa
        || !usuarioLogado.Empresa.modalidade
    ) {
        return ''
    }
    return usuarioLogado.Empresa.modalidade
}

/**
 * Modalidades em que o painel de atualizações do sistema não existe.
 *
 * As atualizações são escritas para o ERP completo — estoque, financeiro,
 * pedidos, impressão. Na modalidade Fiscal (`FIS`), que só emite documentos
 * fiscais, o cliente recebia novidades de telas que a assinatura dele não tem,
 * com link para uma listagem que nem sequer existe no build `/fiscal`. Para
 * essas modalidades a funcionalidade é tratada como inexistente: sem aba no
 * topo, sem chamada à API e sem rota.
 */
const MODALIDADES_SEM_ATUALIZACOES = ['FIS']

export const possuiAtualizacoes = (usuarioLogado = Vue.prototype.$usuarioLogado) => {
    const modalidade = pegaModalidade(usuarioLogado)
    // Sem sessão carregada não se esconde nada — quem decide é o layout Interno,
    // que só monta depois do usuário logado.
    if (!modalidade) {
        return true
    }
    return MODALIDADES_SEM_ATUALIZACOES.indexOf(modalidade) === -1
}
